/* tslint:disable */
/* eslint-disable */
/**
 * ClimatePartner API Calculation Service
 * A Unified API for all ClimatePartner products
 *
 * The version of the OpenAPI document: 1.6.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export enum InlandShipType {
    IbEuBu = 'ib-eu-bu',
    IbGrBu = 'ib-gr-bu',
    IbJoBu = 'ib-jo-bu',
    IbEuCt = 'ib-eu-ct',
    IbGrCt = 'ib-gr-ct',
    IbJoCt = 'ib-jo-ct',
    IbPc2x2Bu = 'ib-pc-2x2-bu',
    IbPc2x2Ct = 'ib-pc-2x2-ct'
}



